import BASE_URL from "../config";

export const getProducts = async ({
  categoryId = "",
  subcategoryId = "",
  page = 1,
  limit = 12,
} = {}) => {

  const params = new URLSearchParams();

  if (categoryId) {
    params.append("categoryId", categoryId);
  }

  if (subcategoryId) {
    params.append("subcategoryId", subcategoryId);
  }

  params.append("page", page);
  params.append("limit", limit);

  const response = await fetch(
    `${BASE_URL}/products?${params.toString()}`
  );

  const result = await response.json();

  return result;
};


export const getProductById = async (id) => {

  const response = await fetch(
    `${BASE_URL}/products/${id}`
  );

  const result = await response.json();

  return result;
};

// Header search type-ahead — slim, ranked product matches for a query.
// Pass an AbortSignal so a newer keystroke can cancel an in-flight request.
export const suggestProducts = async (query, { limit = 6, signal } = {}) => {

  const params = new URLSearchParams({ q: query, limit });

  const response = await fetch(
    `${BASE_URL}/products/suggest?${params.toString()}`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(`Suggest API failed: ${response.status}`);
  }

  const result = await response.json();

  return result?.data?.suggestions || [];
};

// Highly rated products from every category/subcategory (average rating above
// minRating, default 3 on the server), best rated first.
export const getTopRatedProducts = async ({ page = 1, limit = 12, minRating, signal } = {}) => {

  const params = new URLSearchParams({ page, limit });

  if (minRating !== undefined) {
    params.append("minRating", minRating);
  }

  const response = await fetch(
    `${BASE_URL}/products/top-rated?${params.toString()}`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(`Top rated products API failed: ${response.status}`);
  }

  const result = await response.json();

  if (result?.success === false) {
    throw new Error(result.message || "Top rated products fetch failed");
  }

  return result?.data?.products || [];
};

// Suggested products — same subcategory and same category as this product.
export const getRelatedProducts = async (id, limit = 8) => {

  const response = await fetch(
    `${BASE_URL}/products/${id}/related?limit=${limit}`
  );

  const result = await response.json();

  return result;
};